export default {"src":"/_next/static/media/silverPlanBackground.9c3d48d4.svg","height":94,"width":328,"blurWidth":0,"blurHeight":0};